var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-modal',{attrs:{"visible":_vm.visible,"title":_vm.title,"footer":null},on:{"cancel":_vm.handleCancel}},[_c(_vm.bodyComponent,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }